import { createReducer, on } from '@ngrx/store';
import * as SettingsActions from './settings.actions';
import { initialSettingsState } from './settings.state';

export const settingsReducer = createReducer(
    initialSettingsState,

    on(SettingsActions.setSettings, (state, { settings }) => ({
        ...state,
        settings,
    })),
);
